var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9321 13.0679C11.2426 13.3633 11.2426 13.848 10.9321 14.1434C10.6367 14.4387 10.152 14.4387 9.85664 14.1434C8.37977 12.6665 8.37977 10.2656 9.85664 8.78875L12.5377 6.10765C14.0146 4.63078 16.4155 4.63078 17.8923 6.10765C19.3692 7.58453 19.3692 9.98539 17.8923 11.4623L16.7639 12.5907C16.7714 11.9697 16.673 11.3487 16.4609 10.7579L16.8169 10.3944C17.7106 9.50825 17.7106 8.06925 16.8169 7.18312C15.9308 6.28942 14.4917 6.28942 13.6056 7.18312L10.9321 9.85664C10.0384 10.7428 10.0384 12.1818 10.9321 13.0679ZM13.0679 9.85664C13.3633 9.56127 13.848 9.56127 14.1434 9.85664C15.6202 11.3335 15.6202 13.7344 14.1434 15.2113L11.4623 17.8923C9.98539 19.3692 7.58453 19.3692 6.10765 17.8923C4.63078 16.4155 4.63078 14.0146 6.10765 12.5377L7.23614 11.4093C7.22856 12.0303 7.32702 12.6513 7.53909 13.2497L7.18312 13.6056C6.28942 14.4917 6.28942 15.9308 7.18312 16.8169C8.06925 17.7106 9.50825 17.7106 10.3944 16.8169L13.0679 14.1434C13.9616 13.2572 13.9616 11.8182 13.0679 10.9321C12.7574 10.6367 12.7574 10.152 13.0679 9.85664Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/IconLink.ab919e0762e4aad62b45ae549703a605.svg";
export { ForwardRef as ReactComponent };